import {value} from "lodash/seq";

export default {
  data () {
    return {
      columns: [
        {
          label: 'Документ id',
          field: 'id',
          name: 'document_id',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Номер',
          field: 'bill_number',
          name: 'id',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Сумма',
          field: 'amount',
          name: 'id',
          sortable: true,
          filter: '',
          align: 'left',
          format: (value) => this.formatAmount(value)
        },
        {
          label: 'Дата создания',
          field: 'id',
          name: 'created_at',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Период услуги',
          field: 'id',
          name: 'period',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Наименование документа',
          field: 'document_name',
          name: 'source_store',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Статус',
          field: 'status',
          name: 'status',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Ссылка во Вчасно',
          field: 'source_vchasno',
          name: 'source_vchasno',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Действия',
          field: 'id',
          name: 'edit',
          sortable: false,
          align: 'right',
        }
      ],
    }
  },

  computed:{
    parentComponentIsModal(){
      return this.$parent.$options.name === 'QModal';
    }
  },

  methods: {
    formatAmount(amount) {
      return (amount / 100).toFixed(2);
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/ActsList/mixins/columns.js